import React from "react";
import "./navbar.css";
import volcano from "./logovolcano.png";
import Aos from "aos";
import "aos/dist/aos.css";
function Navbar() {
  React.useEffect(() => {
    Aos.init();
  }, []);
  return (
    <div class="nav">
      <input type="checkbox" id="nav-check" />
      <div class="nav-header" data-aos="zoom-in" data-aos-duration="1500">
        <div style={{ marginLeft: "30px" }} class="nav-title">
          <a href="#" style={{ textDecoration: "none", color: "orange" }}>
            <img src={volcano} width="60px" height="56px" /> Volcano
          </a>
          <i class="fa fa-food"></i>
        </div>
      </div>
      <div class="nav-btn">
        <label for="nav-check">
          <span></span>
          <span></span>
          <span></span>
        </label>
      </div>

      <div class="nav-links">
        <a href="#">
          {" "}
          <i class="fa fa-home"></i> Accueil
        </a>
        <a href="#tendances">
          {" "}
          <i class="fas fa-concierge-bell"></i> Services
        </a>
        <a href="#menu">
          {" "}
          <i class="fas fa-utensils"></i> Menu
        </a>
        <a href="#temoignages">
          {" "}
          <i class="fa fa-edit"></i> Avis
        </a>
        <a href="#apropos">
          <i class="fa fa-question-circle"></i> A propos
        </a>
        <a href="#galerie">
          {" "}
          <i class="fa fa-file-image-o"></i> Galerie
        </a>
        <a href="#contact">
          {" "}
          <i class="fa fa-phone"></i> Contactez Nous
        </a>
      </div>
    </div>
  );
}

export default Navbar;
